import React from "react";
import Nav from "./Nav";

const Home = () => {
  return (
    <main id="main" className="bg-img">
      <div id="bgImg" className="container">
        <div className="container">
          <Nav />

          <div className="content">
            <span id="back_perfect">PERFECT</span>
            <h1>PERFECT</h1>
            <p style={{width: "85%"}}>
              Software and design company
              creating innovative digital solutions with a focus on seamless user experiences.
            </p>
            <a
              href="/about"
              data-target="#carouselExampleCaptions"
              data-slide-to="1"
            >
              MORE
            </a>
          </div>

          <div className="social-media">
            <a href="https://www.facebook.com/Perfect-151150445074122">
              <img src="img/facebook.png" />
            </a>
            <a href="https://www.instagram.com/perfect94446783/?fbclid=IwAR14fVz3P2rQ5x8Y8sAlERhd1ldCJhGDPt8M1KAoDsH3sO-y_vDRKNy4Yqg">
              <img src="img/instagram.png" />
            </a>
            <a href="https://www.youtube.com/channel/UC-RBwShQdGVl8aQCo2tyHnA/featured">
              <img src="img/youtube.png" />
            </a>

            <span>SOCIAL MEDIA</span>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
